<script>

    import { createEventDispatcher } from 'svelte'

    const dispatch = createEventDispatcher()

    export let label = null
    export let value = null
    export let placeholder = ''
    export let pattern = null
    export let maxlength = null

    export let required = true

    export let readonly = false

    export let inputType = 'text'

    const uid = `input-${Math.random().toString(36).slice(2, 9)}`

</script>

<div class="field">
    {#if label}
        <label for={uid} class="label">{ label }</label>
    {/if}
    <div class="control">
        {#if inputType === 'email'}
            <input id={uid} bind:value={value} on:keyup on:keyup={e => e.code === 'Enter' && dispatch('enter')} class="input" type="email"
                { pattern } { placeholder } { required } { maxlength } { readonly } >
        {:else}
            <input id={uid} bind:value={value} on:keyup on:keyup={e => e.code === 'Enter' && dispatch('enter')} class="input" type="text"
                { pattern } { placeholder } { required } { maxlength } { readonly } >
        {/if}
    </div>
</div>
